import { apis } from "./api"
import axios from "./axiosInterceptor"

export const createAdmin = async (body) => {
    return await axios.post(apis.admin.create, body)
}

export const fetchAdmins = async (page, record_per_page) => {
    return await axios.get(`${apis.admin.fetch}?page=${page}&records_per_page=${record_per_page}`)
}